// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__34e3C","modalForm":"UpgradeEpcsModal_modalForm__1DPJ7","modalFooter":"UpgradeEpcsModal_modalFooter__enfgc"};